var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import id from "@irati/utils/id";
import { IconButton } from "./styled";
var SliderNav = function (_a) {
    var _b = _a.currentSlide, currentSlide = _b === void 0 ? 0 : _b, _c = _a.slideCount, slideCount = _c === void 0 ? 0 : _c, _d = _a.slidesToShow, slidesToShow = _d === void 0 ? 0 : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.show, show = _f === void 0 ? true : _f, props = __rest(_a, ["currentSlide", "slideCount", "slidesToShow", "onClick", "show"]);
    var previousNav = props.previousNav, alwaysShow = props.alwaysShow;
    var idNamespace = id("slider-nav", props);
    if (!show) {
        return null;
    }
    if (!alwaysShow) {
        // disable next
        if (!previousNav && slideCount <= (currentSlide + slidesToShow)) {
            return null;
        }
        // disable prev
        if (previousNav && currentSlide <= 0) {
            return null;
        }
    }
    return (React.createElement(IconButton, { id: idNamespace, previousNav: previousNav, onClick: onClick, icon: previousNav ? "angleLeft" : "angleRight" }));
};
export default SliderNav;
